const CRTEffect = ({ p5, width, height }) => {
  p5.push();
  
  // Bloom effect with flicker
  p5.push();
  const bloomTime = p5.frameCount * 0.05;
  const slowFlicker = 0.8 + Math.sin(bloomTime * 0.3) * 0.2;
  const mediumFlicker = 0.9 + Math.sin(bloomTime * 0.7) * 0.1;
  const fastFlicker = 0.95 + Math.sin(bloomTime * 2) * 0.05;
  let bloomIntensity = slowFlicker * mediumFlicker * fastFlicker;
  
  // First pass - large blur with flicker
  p5.drawingContext.filter = 'blur(6px)';
  p5.tint(255, 60 * bloomIntensity);
  p5.image(p5.get(), 0, 0);
  
  // Second pass - medium blur
  p5.drawingContext.filter = 'blur(4px)';
  p5.tint(255, 50 * bloomIntensity);
  p5.image(p5.get(), 0, 0);
  
  // Third pass - tight blur for sharp highlights
  p5.drawingContext.filter = 'blur(2px)';
  p5.tint(255, 40 * bloomIntensity);
  p5.image(p5.get(), 0, 0);
  
  p5.drawingContext.filter = 'none';
  p5.pop();

  // Digital corruption effects
  if (p5.random() < 0.02) {
    p5.push();
    const corruptionType = p5.floor(p5.random(3));
    
    switch(corruptionType) {
      case 0: // Pixel sorting effect
        const sortBand = {
          y: p5.random(height),
          height: p5.random(20, 50)
        };
        p5.loadPixels();
        for (let y = sortBand.y; y < sortBand.y + sortBand.height; y += 2) {
          const lineOffset = p5.random(-20, 20);
          p5.image(p5.get(0, y, width, 2),
                  lineOffset, y, width, 2);
        }
        break;
        
      case 1: // Data moshing effect
        const moshSegments = p5.floor(p5.random(3, 8));
        const moshHeight = height / moshSegments;
        for (let i = 0; i < moshSegments; i++) {
          const sourceY = i * moshHeight;
          const destY = sourceY + p5.random(-20, 20);
          const segmentHeight = moshHeight + p5.random(-10, 10);
          p5.image(p5.get(0, sourceY, width, segmentHeight),
                  p5.random(-15, 15), destY, width, segmentHeight);
        }
        break;
        
      case 2: // Extreme color channel splitting
        const splitAmount = p5.random(10, 20);
        p5.blendMode(p5.SCREEN);
        p5.tint(255, 0, 0, 150);
        p5.image(p5.get(), splitAmount, 0);
        p5.tint(0, 255, 0, 150);
        p5.image(p5.get(), 0, p5.random(-5, 5));
        p5.tint(0, 0, 255, 150);
        p5.image(p5.get(), -splitAmount, 0);
        break;
    }
    p5.pop();
  }

  // Enhanced glitch effects
  if (p5.random() < 0.04) {
    p5.push();
    const glitchType = p5.random([0, 1, 2, 3]);
    
    switch(glitchType) {
      case 0: // Aggressive horizontal tears
        const numTears = p5.random(3, 6);
        for (let i = 0; i < numTears; i++) {
          const tearY = p5.random(height);
          const tearHeight = p5.random(5, 20);
          const tearOffset = p5.random(-15, 15);
          p5.image(p5.get(0, tearY, width, tearHeight),
                  tearOffset, tearY, width, tearHeight);
          
          if (p5.random() < 0.5) {
            p5.stroke(p5.random(255), 100);
            for (let x = 0; x < width; x += 3) {
              if (p5.random() < 0.3) {
                p5.line(x, tearY, x, tearY + tearHeight);
              }
            }
          }
        }
        break;
        
      case 1: // RGB shift
        const shifts = [
          {r: 255, g: 0, b: 0, x: p5.random(3, 6), y: p5.random(-2, 2)},
          {r: 0, g: 255, b: 0, x: p5.random(-2, 2), y: p5.random(-2, 2)},
          {r: 0, g: 0, b: 255, x: p5.random(-6, -3), y: p5.random(-2, 2)}
        ];
        shifts.forEach(shift => {
          p5.tint(shift.r, shift.g, shift.b, 130);
          p5.image(p5.get(), shift.x, shift.y);
        });
        break;
        
      case 2: // Block scramble
        const blockSize = p5.random(20, 40);
        const numBlocks = p5.random(3, 6);
        for (let i = 0; i < numBlocks; i++) {
          const sourceX = p5.random(width - blockSize);
          const sourceY = p5.random(height - blockSize);
          const destX = sourceX + p5.random(-30, 30);
          const destY = sourceY + p5.random(-30, 30);
          p5.image(p5.get(sourceX, sourceY, blockSize, blockSize),
                  destX, destY, blockSize, blockSize);
        }
        break;
        
      case 3: // Wave distortion
        const waveSegments = 20;
        const segmentHeight = height / waveSegments;
        const waveTime = p5.frameCount * 0.1;
        for (let i = 0; i < waveSegments; i++) {
          const offsetX = Math.sin(waveTime + i * 0.2) * p5.random(5, 15);
          p5.image(p5.get(0, i * segmentHeight, width, segmentHeight),
                  offsetX, i * segmentHeight, width, segmentHeight);
        }
        break;
    }
    p5.pop();
  }
  
  // Draw scanlines (keeping the working version)
  p5.noStroke();
  for (let y = 0; y < height; y += 3) {
    p5.fill(0, 40);
    p5.rect(0, y, width, 1);
  }
  
  p5.pop();
};

export default CRTEffect;